import { render, staticRenderFns } from "./SuppliesDeleteModal.vue?vue&type=template&id=acee8496"
import script from "./SuppliesDeleteModal.vue?vue&type=script&lang=js"
export * from "./SuppliesDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./SuppliesDeleteModal.vue?vue&type=style&index=0&id=acee8496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports